import { ref } from '@vue/composition-api';

const events = ref({});

export default function useGlobalEventEmitter(namespace) {
  if (!events.value[namespace]) {
    events.value[namespace] = {};
  }

  function emitEvent(event, data) {
    const eventHandlers = events.value[namespace][event];
    if (!eventHandlers) {
      return;
    }
    eventHandlers.forEach((handler) => {
      handler(data);
    });
  }

  function unsubscribe(event, handler) {
    events.value[namespace][event] = events.value[namespace][event].filter((eventHandler) => handler !== eventHandler);
  }

  function subscribe(event, handler) {
    let handlers = events.value[namespace][event];
    if (!handlers) {
      handlers = [];
    }

    if (handlers.some((h) => handler === h)) {
      return;
    }

    handlers.push(handler);
    events.value[namespace][event] = handlers;
    return () => {
      unsubscribe(event, handler);
    };
  }

  return {
    emitEvent,
    subscribe,
  };
}
